module.exports = {"id":"dp3_4l3q1","text":"Computational Thinking and Programming","instructions":"Which option best describes an algorithm in computational thinking?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.4","questionType":"PickOne","random":true,"options":[{"id":"dp3_4l3q1-a1","text":"A defined sequence of steps to solve a task","score":3.7},{"id":"dp3_4l3q1-a2","text":"A general idea without defined execution steps","score":1.3},{"id":"dp3_4l3q1-a3","text":"A hardware component inside a computer system","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.4/l3q1.json
// module id = 1180
// module chunks = 41